module.exports = __webpack_public_path__ + "static/GreycliffCF-DemiBold-7f7cca9d02dc0095afdebb2df43bb367.ttf";